import $ from 'jquery'

const CN_PART = '.part'
const CN_SNAP = '.snap'
export const snapping = {
  data () {
    return {
      dg: null,
      snapped: {
        elct: {},
        sockets: []
      },
      activate: {
        dg: null,
        el: null
      }
    }
  },
  methods: {
    setDraggable (dg) {
      this.dg = dg
    },
    isSnapped (part) {
      const THRESHOLD = '40%'
      if (!part || !this.activate.el) return
      const sockets = this.activate.el.querySelectorAll(`#${this.activate.el.id} g.socket`)
      const pins = part.querySelectorAll(CN_SNAP)
      if (pins.length <= 0 || sockets.length <= 0) return false
      let cnt = 0
      for (let j = 0; j < pins.length; j++) {
        for (let k = 0; k < sockets.length; k++) {
          if (window.Draggable.hitTest(sockets[k], pins[j], THRESHOLD)) {
            cnt++
            break
          }
        }
      }
      return cnt === pins.length
    },
    findSnappedElctAll () {
      const parts = $(CN_PART)
      if (parts.length === 0) return
      const elct = []
      for (let i = 0; i < parts.length; i++) {
        if (parts[i].classList.contains('snapped')) continue
        if (this.isSnapped(parts[i])) {
          elct.push(parts[i])
        }
      }
      return elct
    },
    findSnappedSockets (elct) {
      const snapped = []
      if (!this.activate.el || !elct) return
      const THRESHOLD = '40%'
      const sockets = this.activate.el.querySelectorAll(`#${this.activate.el.id} g.socket`)
      if (!sockets) return snapped
      for (let i = 0; i < elct.length; i++) {
        if (elct[i].classList.contains('snapped')) continue
        const pins = elct[i].querySelectorAll(CN_SNAP)
        const temp = []
        for (let j = 0; j < pins.length; j++) {
          for (let k = 0; k < sockets.length; k++) {
            if (window.Draggable.hitTest(sockets[k], pins[j], THRESHOLD)) {
              const obj = {}
              obj[pins[j].id] = sockets[k]
              temp.push(obj)
              break
            }
          }
        }
        if (temp.length === pins.length) {
          temp.forEach(obj => {
            snapped.push(obj)
          })
        }
      }
      return snapped
    },
    snapDrag (elcts) {
      if (!this.activate.dg) return
      const boardDeltaX = this.activate.dg.deltaX // 현재 드래그 중인 객체의 좌표 변화값
      const boardDeltaY = this.activate.dg.deltaY
      for (let i = 0; i < elcts.length; i++) {
        const currentElct = elcts[i]
        const partX = window.gsap.getProperty(currentElct, 'x') // 부품의 현재 좌표
        const partY = window.gsap.getProperty(currentElct, 'y')
        const x = partX + boardDeltaX
        const y = partY + boardDeltaY
        window.gsap.to(currentElct, 0, {
          x, // 현재 좌표 + 좌표 변화값
          y
        }) // gsap.to 애니메이션 이용
      }
    },
    snapEnd () {
      if (!this.activate.el) return
      this.removeSnapClassAll()
      const elct = this.findSnappedElctAll()
      const sockets = this.findSnappedSockets(elct)
      if (!sockets || !elct) return
      this.$store.commit('elct/setSnappedSockets', sockets)
      this.snapped.elct[this.activate.el.id] = elct
      this.snapped.sockets = sockets
      if (!this.snapped.sockets.length) return
      this.snapped.sockets.forEach(sock => {
        const el = Object.values(sock)[0]
        el.classList.add('snapped')
      })
    },
    removeSnapClassAll () {
      const sockets = this.activate.el.querySelectorAll(`#${this.activate.el.id} g.socket`)
      sockets.forEach(sock => {
        if (sock.classList.contains('snapped')) {
          sock.classList.remove('snapped')
        }
      })
    }
  }
}
